module.exports = __webpack_public_path__ + "img/treatment-history-section-fr.4841d321.jpg";